<template>
  <div class="wh100">
    <!-- //0巡检 1保养 2维修 3外委 -->
    <OperationWorkOrder
      ref="OperationWorkOrder"
      workOrderType="0"
    ></OperationWorkOrder>
  </div>
</template>
<script>
import OperationWorkOrder from '@/views/Operation/OperationWorkOrder/OperationWorkOrder.vue'
export default {
  data() {
    return {}
  },
  props: {},
  components: { OperationWorkOrder },
  methods: {},
  mounted() {},
  created() {},
  computed: {},
  watch: {},
}
</script>
<style lang="scss" scoped></style>
